import Tables from 'src/class/Tables';
import i18n from '../../../../i18n';



const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: "name",
      label: i18n.t('common_words.name'),
      minWidth: 100,
      sortable: true,
    },
    {
      prop: "nit",
      label: i18n.t('common_words.nit'),
      minWidth: 100,
      sortable: true,
      align: 'center',
    },
    {
      prop: "comercial_activity",
      label: i18n.t('common_words.comercial_activity'),
      minWidth: 150
    },
    {
      prop: "address",
      label: i18n.t('common_words.address'),
      minWidth: 150,
      sortable: true,
    },
    {
      prop: "concat_types",
      label: i18n.t('common_words.type'),
      minWidth: 100,
      sortable: true,
    }
  ];

  const Search = { ...Tables.Search };
  return { Table, Search };
};

export default configTable;
